import { GenericObject, copyFields } from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { Supplier } from '../../../common/models/supplier';

export class SupplierAccount {
    public id?: number;
    public account!: Supplier;
    public contact?: Contact;
    /** Where the supplier has its inquiries sent whoever the contact is (R-208). */
    public fixedRecipientEmails?: string[];

    public static fromPlainObject(object: GenericObject): SupplierAccount {
        const supplierAccount = new SupplierAccount();

        copyFields(object, supplierAccount);

        if (object['account']) {
            supplierAccount.account = Supplier.fromPlainObject(object['account']);
        }

        if (object['contact']) {
            supplierAccount.contact = Contact.fromPlainObject(object['contact']);
        }

        return supplierAccount;
    }
}
